;(function (angular, _) {
  'use strict'

  /**
   * TODO
   *  add component bindings:
   *  - used columns (<)
   *  - onSelect (&)
   */
  class PaymentListController {
    constructor (
      // Angular
      // Libs
      // Managers
      EntityManager, InvoiceManager,
      // Services
      ColumnService, PaginationModel, UtilService
      // Const
      // Resolved
    ) {
      // DI
      this.invoiceManager = InvoiceManager
      this.columnService = ColumnService
      this.paginationModel = PaginationModel
      this.entityManager = EntityManager
      this.utilService = UtilService

      this.columns = []
      this.loading = true
      this.payments = []
      this.pagination = {}
      this.dateFormat = 'dd/MM/yyyy'
      this.sort = { key: 'payments.date', asc: false }
    }

    $onInit () {
      return Promise.all([this.columnService.init(), this.paginationModel.get('paymentList')]).then(([colService, pagination]) => {
        // Composant détruit avant la résolution : on retire tout de suite le watcher $rootScope
        if (this.destroyed) return pagination.destroy()
        this.columns = this.columnService.buildColumns([], this.columnService.getColumns('payment'))
        this.pagination = pagination
        return this.getList(this.pagination)
      })
    }

    $onDestroy () {
      // Retire le watcher $rootScope de la pagination créée par ce composant
      this.destroyed = true
      if (this.pagination && this.pagination.destroy) this.pagination.destroy()
    }

    getList (pagination = this.pagination) {
      this.loading = true
      const numberResult = pagination.toQueryOptions().limit
      const skip = pagination.toQueryOptions().skip
      const sort = {
        $sort: {}
      }
      sort.$sort[this.sort.key] = this.sort.asc ? 1 : -1

      let conditions = {
        'payments.0': { $exists: true }
      }
      if (this.baseQuery) {
        conditions = { ...conditions, ...this.baseQuery }
      }

      const query = this.invoiceManager.query({
        conditions,
        aggregate: [
          {
            $project: {
              _id: 1,
              payments: 1,
              title: 1,
              number: 1,
              client: 1,
              company: 1,
              date: 1,
              dueDate: 1,
              reference: 1,
              isArchived: 1,
              isDeleted: 1,
              numberFormat: 1
            }
          },
          // Make 1 line per payment
          {
            $unwind: '$payments'
          },
          // Populates
          {
            $lookup: {
              from: 'crm.entities',
              foreignField: '_id',
              localField: 'client',
              as: 'client'
            }
          },
          {
            $lookup: {
              from: 'kilo.creditnotes',
              foreignField: '_id',
              localField: 'payments.ref.value',
              as: 'payments.ref.value'
            }
          },
          // Switch from array to object
          {
            $addFields: {
              client: { $arrayElemAt: ['$client', 0] }
            }
          },
          sort,
          // Count total elements
          {
            $group: {
              _id: null,
              count: {
                $sum: 1
              },
              results: {
                $push: '$$ROOT'
              }
            }
          },
          // slice results for pagination
          {
            $project: {
              count: 1,
              rows: {
                $slice: [
                  '$results',
                  skip,
                  numberResult
                ]
              }
            }
          }

        ]
      })
      this.invoiceManager.aggregate(query, { ignoreArchived: true }).then(({ data }) => {
        this.loading = false
        const content = data[0] || {count: 0, rows: []}

        this.pagination.totalElements = content.count
        this.payments = content.rows.map(v => {
          return { ...v, client: this.entityManager.create(v.client), number: this.utilService.getInvoiceNumber(v, 'invoice', v.numberFormat) }
        })
      })
    }

    sortColumn (column, skipReverse) {
      if (this.sort.key === column && !skipReverse) {
        this.sort.asc = !this.sort.asc
      }
      this.sort.key = column

      return this.getList(this.pagination)
    }

    dropColumn (source, target) {
      const newIndex = this.columns.findIndex(({ id }) => id === target)
      const oldIndex = this.columns.findIndex(({ id }) => id === source)
      this.columns.splice(newIndex, 0, this.columns.splice(oldIndex, 1)[0])
    }
  }

  PaymentListController.$inject = [
    // Angular
    // Libs
    // Managers
    'EntityManager', 'InvoiceManager',
    // Services
    'ColumnService', 'PaginationModel', 'UtilService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('paymentList', {
      templateUrl: '/app/common/components/payment-list/payment-list.template.html',
      bindings: {
        baseQuery: '<'
      },
      controller: PaymentListController
    })
})(window.angular, window._)
